export default "<div class=\"card item_card\" [id]=\"customer.id\">\r\n</div>"